<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="物料标签打印"
        width="600px"
        top="5vh"
        @close="$reset('form')">
      <div>
        <el-form
            ref="form"
            :model="model"
            class="form"
            label-width="80px">
<!--          <el-form-item label="起始数量" :rules="$rule.notNull">
            <el-input v-model="model.startNum" type="number" min="1"/>
          </el-form-item>
          <el-form-item label="订单数量" :rules="$rule.notNull">
            <el-input v-model="model.printSize" type="number" min="1"/>
          </el-form-item>-->
          <el-form-item prop="templateType" label="模板类型" :rules="$rule.notNull">
            <el-select v-model="model.templateType" :loading="typeLoading" clearable placeholder="请选择">
              <el-option
                  v-for="item in templateTypes"
                  :key="item.itemId"
                  :label="item.itemName"
                  :value="item.itemId"/>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handlePrint">打印</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "MaterialLabelPrintDialog",
    components: {},
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        typeLoading: false,
        templateTypes: [],
        orderInfo: {},
        model: {
          id: "",
          templateType: "",
          printSize: "",
          startNum: 1,
        },
      };
    },
    methods: {
      open(obj) {
        this.orderInfo = JSON.parse(JSON.stringify(obj));
        this.model.id = this.orderInfo.pkid;
        this.model.printSize = this.orderInfo.quantity;
        this.getTemplateTypes();
        this.dialogVisible = true;
      },
      getTemplateTypes() {
        this.typeLoading = true;
        this.$http
            .get("basic", "materialLabelPrints/list/template/type/all")
            .then((resp) => {
              this.templateTypes = resp.data || [];
            }).finally(() => {
          this.typeLoading = false;
        });
      },
      handlePrint() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .postForFile("basic", `taskDispatchBills/pt/${this.model.templateType}/${this.model.id}/${this.model.startNum}/${this.model.printSize}`)
              .then((res) => {
                let blob = new Blob([res.data], {type: "application/pdf"});
                let pdfUrl = window.URL.createObjectURL(blob);
                window.open(pdfUrl);
                this.submitLoading = false;
              }).finally(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
